<template>
  <div>
    <h2 class="text-2xl font-bold text-gray-900 mb-6">Welcome Back</h2>
    
    <form @submit.prevent="handleLogin" class="space-y-4">
      <!-- Email or Username -->
      <div>
        <label for="email" class="label">Email or Username</label>
        <input
          id="email"
          v-model="form.email"
          type="text"
          required
          class="input"
          placeholder="you@example.com or username"
          :disabled="loading"
        />
      </div>
      
      <!-- Password -->
      <div>
        <label for="password" class="label">Password</label>
        <input
          id="password"
          v-model="form.password"
          type="password"
          required
          class="input"
          placeholder="••••••••"
          :disabled="loading"
        />
      </div>
      
      <!-- Remember Me & Forgot Password -->
      <div class="flex items-center justify-between">
        <label class="flex items-center">
          <input
            v-model="rememberMe"
            type="checkbox"
            class="rounded border-gray-300 text-primary-600 focus:ring-primary-500"
          />
          <span class="ml-2 text-sm text-gray-600">Remember me</span>
        </label>
        <a href="#" class="text-sm text-primary-600 hover:text-primary-500">
          Forgot password?
        </a>
      </div>
      
      <!-- Submit Button -->
      <button
        type="submit"
        :disabled="loading"
        class="w-full btn btn-primary flex items-center justify-center"
      >
        <span v-if="!loading">Sign In</span>
        <span v-else class="flex items-center">
          <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Signing in...
        </span>
      </button>
    </form>
    
    <!-- Sign Up Link -->
    <div class="mt-6 text-center">
      <p class="text-sm text-gray-600">
        Don't have an account?
        <RouterLink to="/register" class="font-medium text-primary-600 hover:text-primary-500">
          Sign up
        </RouterLink>
      </p>
    </div>
    
    <!-- Demo Credentials -->
    <div class="mt-6 p-4 bg-primary-50 rounded-lg">
      <p class="text-sm text-primary-800 font-medium mb-2">Demo Credentials:</p>
      <p class="text-sm text-primary-700">Email: demo@eldercare.com or Username: demo</p>
      <p class="text-sm text-primary-700">Password: Demo123!</p>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { RouterLink } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const authStore = useAuthStore()

const form = ref({
  email: '',
  password: ''
})

const rememberMe = ref(false)
const loading = ref(false)

async function handleLogin() {
  loading.value = true
  try {
    await authStore.login(form.value)
  } catch (error) {
    // Error handled in store
  } finally {
    loading.value = false
  }
}
</script>